module.exports = __webpack_public_path__ + "media/images/gallery-4-f0eb88e9.jpg";